import { Controller, useFormContext } from "react-hook-form";
import { get } from "lodash";

import {
  Field,
  FieldDescription,
  FieldError,
  FieldLabel,
} from "components/ui/field";
import { PhoneInput } from "components/ui/phone-input";

const NAME = "call_center.zendesk_inbound_number";

export function ZendeskNumberField() {
  const {
    control,
    formState: { errors },
  } = useFormContext();
  const error = get(errors, NAME);
  return (
    <Controller
      name={NAME}
      control={control}
      render={({ field }) => (
        <Field data-invalid={error ? true : undefined}>
          <FieldLabel htmlFor={NAME}>Zendesk Inbound Number</FieldLabel>
          <PhoneInput
            id={NAME}
            placeholder="+18885555555"
            value={field.value ?? undefined}
            onChange={value => field.onChange(value ?? null)}
            onBlur={field.onBlur}
            aria-invalid={error ? true : undefined}
          />
          <FieldDescription>
            Number used to forward inbound calls, for example when a contact
            calls back the caller ID number.
          </FieldDescription>
          <FieldError>{error?.message}</FieldError>
        </Field>
      )}
    />
  );
}
